import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";

import { useUserRole } from "components/Sidebar/hooks/useUserRole";
import { AccessDenied } from "components/ui/AccessDenied";
import { SidebarMenu } from "components/ui/SidebarMenu";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";
import { isTenantTypeAllowed } from "utils/tenantAccess";

import { SETTINGS_MENU_ITEMS } from "./constants";
import styles from "./SettingsLayout.module.css";

const SettingsLayout = () => {
  const { hasAccess, tenantType } = useUserRole();
  const { data: practiceSettings } = usePracticeSettings();

  const filteredMenuItems = useMemo(() => {
    let items = SETTINGS_MENU_ITEMS;
    if (practiceSettings?.healthLink === false) {
      items = items.filter((item) => item.label !== "Healthlink");
    }
    return items.filter((item) =>
      isTenantTypeAllowed(item.tenantTypes, tenantType)
    );
  }, [practiceSettings, tenantType]);

  if (!hasAccess(["ADMIN", "ROLE_ADMIN"])) {
    return <AccessDenied />;
  }

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <SidebarMenu items={filteredMenuItems} iconSize={16} testId="settings-nav" />
      </aside>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export { SettingsLayout };
